<template>
  <Layout>
    <b-overlay :show="isLoading" rounded="sm">

    <div class="card">
      <div class="card-body">
        <PageHeader :title="title" :items="items" />
        <div class="form-row">
          <div class="form-group col-md-9">
            <label>Expediente</label>
            <v-select
                :options="expedientes"
                label="obra_expediente"
                :reduce="desc=>desc.expediente_id"
                v-model="expediente_id"
                @input="cargarCurvaS()"

            />

          </div>
        </div>


         <div class="row">
           <div class="col-md-12">
             <apexchart width="100%" type="line" :options="options" :series="series"></apexchart>
           </div>

         </div>

        </div>
      </div>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Reportes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Reportes de avance",
      items: [
        {
          text: "Avance",
        }
      ],
      isLoading: false,
      server: process.env.VUE_APP_BACKEND,
      options: {
        chart: {
          id: 'vuechart-example',
        },

        xaxis: {
          categories: []
        }
      },
      series: [{
        name: 'series-1',
        data: []
      }]
      ,
      expedientes:[],
      expediente_id:null

    };
  },
  beforeMount() {


  },
  methods: {

    cargarExpedientes(){
      this.isLoading=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/expedientes")
          .then((response)=>{
            this.expedientes=response.data;
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error cargando los expedientes",'warning');
          })
          .finally(()=>this.isLoading=false)
    },
    cargarCurvaS(){
      this.isLoading=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/expedientes/reporte/curva-s/"+this.expediente_id)
          .then((response)=>{
            //this.options.xaxis.categories=response.data.categories;
            this.options=response.data.options;
            this.series=response.data.series;
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error cargando los expedientes",'warning');
          })
          .finally(()=>this.isLoading=false)
    }
  },
  mounted() {
    this.cargarExpedientes();
    //var date= new Date();
    //this.fecha=new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
  }
}
</script>

<style>
.fixtable {
  color: #000000 !important;
}
</style>
